// HDS-R.
export const LOADING: string = 'HDSR_LOADING';
export const SUCCESS: string = 'HDSR_SUCCESS';
export const ERROR: string = 'HDSR_ERROR';
export const INITIALIZE: string = 'HDSR_INITIALIZE';



// WEBPACK FOOTER //
// ./src/constants/HDSR.tsx